import _ from "lodash";
import { createSelector } from "@reduxjs/toolkit";
import { selectAllPlayers } from "../player/playerSlice";
import Provider from "provider";
import logging from "utils/logging";

const log = logging.getLogger("LeaderboardSlice");

const saveSubmissionScoresToLeaderboard =
  (gameId, questionId) => async (dispatch) => {
    // Call the backend to save the scores
    await Provider.commitSubmissionScoresToLeaderboard(gameId, questionId);
  };

const removePlayerFromGame = (gameId, playerId) => async (dispatch) => {
  log.info("Removing player from game", gameId, playerId);
  await Provider.removePlayerFromGame(gameId, playerId);
};

const selectLeaderboardPlayers = createSelector(selectAllPlayers, (players) => {
  return _.sortBy(players, (p) => -p.score);
});

const selectLeaderboardPlayersReverse = createSelector(
  selectAllPlayers,
  (players) => {
    return _.sortBy(players, (p) => p.score);
  }
);

const selectPlayersForFinalPodiums = createSelector(
  selectAllPlayers,
  (players) => {
    return _.sortBy(players, (p) => p.preFinalScore);
  }
);

export {
  removePlayerFromGame,
  selectLeaderboardPlayers,
  selectLeaderboardPlayersReverse,
  selectPlayersForFinalPodiums,
  saveSubmissionScoresToLeaderboard,
};
